export default "__VITE_ASSET__Be7g7GKf__";